// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kit-nvr__metrics{display:grid;grid-template-columns:repeat(auto-fill,186px);justify-content:start}.kit-nvr__metrics .summary-element{max-height:18px;min-height:18px!important}.kit-nvr__metrics--grafana{flex-grow:.25}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
